var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from 'react';
import { Grid, VirtualTable, Table, TableHeaderRow, TableSelection, TableFilterRow, } from '@devexpress/dx-react-grid-bootstrap4';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import { SelectionState, IntegratedSorting, SortingState, IntegratedFiltering, FilteringState, } from '@devexpress/dx-react-grid';
import { GridExporter } from '@devexpress/dx-react-grid-export';
import { saveAs } from 'file-saver';
import { last } from '../../utils/array';
import { ColumnFilterCellIcon, ColumnFilterCell, RowComponent, TableComponentBase, } from './components';
import { RowPlugin } from './plugins';
import { useRowClickHandler } from './hooks';
import { CellFormatterFactory } from './formatters';
import './DataGrid.scss';
export const DataGrid = ({ columns, data, showSortingControls = true, emitSelectedRowData = undefined, emitSelectedCell: emitSelectedColumnName = undefined, customRowClickHandler = undefined, selectByRowClick = true, highlightSelectedColumn = false, virtualScroll = false, showFilter = false, initialColumnSelectionKey = '', exportFileName = 'DataGrid', gridExportRef = undefined, getExportCellValue, gridDropdownProps, tableColumnExtensions = [], }) => {
    const [selectedCell, setSelectedCell] = useState();
    const [rowSelection, setSelection] = useState([0]);
    const { handleRowClick } = useRowClickHandler();
    const onRowSelection = (selectedRow) => {
        setSelection([last(selectedRow)]);
    };
    const updateSelectedColumnName = useCallback((cell) => {
        setSelectedCell(cell);
        if (emitSelectedColumnName)
            emitSelectedColumnName(cell);
    }, [emitSelectedColumnName]);
    const onSave = (workbook) => __awaiter(void 0, void 0, void 0, function* () {
        const buffer = yield workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${exportFileName}.xlsx`);
    });
    useEffect(() => {
        if (!selectedCell &&
            columns &&
            highlightSelectedColumn &&
            initialColumnSelectionKey && (data === null || data === void 0 ? void 0 : data.length)) {
            const firstRow = new Map(Object.entries(data[0]));
            const cell = {
                columnName: initialColumnSelectionKey,
                cellValue: firstRow.get(initialColumnSelectionKey),
            };
            setSelectedCell(cell);
            updateSelectedColumnName(cell);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns, highlightSelectedColumn, initialColumnSelectionKey]);
    const updateSelectedRowData = useCallback((rowData) => {
        if (emitSelectedRowData)
            emitSelectedRowData(rowData);
    }, [emitSelectedRowData]);
    const RowComponentWithProps = (props) => (React.createElement(RowComponent, Object.assign({}, props, { showSelection: selectByRowClick && !highlightSelectedColumn, setSelectedRowData: updateSelectedRowData, rowClickHandler: customRowClickHandler || handleRowClick })));
    return (React.createElement("div", { className: "base-data-grid" },
        React.createElement(Grid, { rows: data, columns: columns },
            React.createElement(CellFormatterFactory, { for: columns.map((col) => col.name), onCellSelected: updateSelectedColumnName, selectedCell: selectedCell, highlightSelectedColumn: highlightSelectedColumn, gridDropdownProps: gridDropdownProps }),
            React.createElement(SortingState, null),
            React.createElement(IntegratedSorting, null),
            React.createElement(FilteringState, { defaultFilters: [] }),
            React.createElement(IntegratedFiltering, null),
            React.createElement(SelectionState, { selection: rowSelection, onSelectionChange: onRowSelection }),
            virtualScroll ? (React.createElement(VirtualTable, { height: "100%", tableComponent: TableComponentBase, rowComponent: RowComponentWithProps, columnExtensions: tableColumnExtensions })) : (React.createElement(Table, { tableComponent: TableComponentBase, rowComponent: RowComponentWithProps, columnExtensions: tableColumnExtensions })),
            React.createElement(TableSelection, { selectByRowClick: selectByRowClick, highlightRow: selectByRowClick, showSelectionColumn: false }),
            React.createElement(TableHeaderRow, { showSortingControls: showSortingControls }),
            showFilter ? (React.createElement(TableFilterRow, { showFilterSelector: true, cellComponent: ColumnFilterCell, iconComponent: ColumnFilterCellIcon })) : null,
            React.createElement(RowPlugin, { RowComponent: RowComponentWithProps })),
        React.createElement(GridExporter, { ref: gridExportRef, rows: data, columns: columns, getCellValue: getExportCellValue, onSave: onSave })));
};
//# sourceMappingURL=DataGrid.js.map